import { useState } from 'react';
import Icon from './Icon';
import Sheet from './Sheet';
import { usesTables } from '../lib/foodTable';

// Where calories come from (UX "Nguồn dữ liệu dinh dưỡng"): one small line under the numbers, shown only when some of
// them were looked up in the two tables (an AI guess or typed numbers get no line). Tapping it opens "Số liệu lấy từ
// đâu?" every time; nothing pops up by itself or stands in the way of saving. "Theo dữ liệu…", never "chứng nhận":
// no logos, nothing that reads as an official endorsement.
const SOURCES = [
  { badge: 'US', name: 'USDA FoodData Central', text: 'Cơ sở dữ liệu dinh dưỡng của Bộ Nông nghiệp Hoa Kỳ.' },
  { badge: 'VN', name: 'Bảng thành phần thực phẩm Việt Nam', text: 'Viện Dinh dưỡng, Bộ Y tế. Dùng cho món và nguyên liệu Việt.' },
];

export function SourceSheet({ open, onClose }) {
  return (
    <Sheet open={open} onClose={onClose} title="Số liệu lấy từ đâu?">
      <div className="flex flex-col gap-4">
        <ul className="flex flex-col gap-3">
          {SOURCES.map((s) => (
            <li key={s.badge} className="flex items-start gap-3">
              <span className="grid size-9 shrink-0 place-items-center rounded-[10px] bg-[#e3f1e9] text-xs font-bold text-[#17804f]">{s.badge}</span>
              <span>
                <span className="block text-[15px] font-semibold">{s.name}</span>
                <span className="block text-sm text-muted">{s.text}</span>
              </span>
            </li>
          ))}
        </ul>
        <p className="rounded-[14px] bg-base-200 p-3 text-sm">
          AI nhận diện món và ước lượng khẩu phần, rồi tính calo theo hai nguồn trên. Khẩu phần là ước tính, nên bạn sửa
          lại nếu biết chính xác.
        </p>
        <button type="button" className="btn btn-primary h-[54px] w-full rounded-2xl border-0 text-base font-bold" onClick={onClose}>Đã hiểu</button>
      </div>
    </Sheet>
  );
}

// `items`: the ingredients behind the numbers; nothing is shown unless some come from a table.
export function SourceLine({ items, className = '' }) {
  const [open, setOpen] = useState(false);
  if (!usesTables(items)) return null;
  return (
    <>
      <button type="button" onClick={() => setOpen(true)}
        className={`flex min-h-8 w-fit items-center gap-1 text-left text-xs text-[#5B6660] ${className}`}>
        <Icon name="info" className="size-3.5 shrink-0" />
        <span>Theo dữ liệu <b className="font-semibold">USDA</b> &amp; <b className="font-semibold">Viện Dinh dưỡng</b></span>
      </button>
      <SourceSheet open={open} onClose={() => setOpen(false)} />
    </>
  );
}
